import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  isOpen     = false;
  isMoreOpen = false;

  toggleMenu(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) this.isMoreOpen = false;
  }

  toggleMore(): void {
    this.isMoreOpen = !this.isMoreOpen;
  }

  closeMore(): void {
    this.isMoreOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-more')) {
      this.isMoreOpen = false;
    }
  }
}
